import { useConfigStore } from '@jwp/ott-common/src/stores/ConfigStore';
import { GetCookie } from '@jwp/ott-common/src/utils/cookie';

import { useAppConfig } from './useAppConfig';

export const useAppInfo = () => {
  const { appConfig, featureFlags, config } = useConfigStore.getState();
  const { isCleengSubscriptionEnabled } = useAppConfig();
  const isUser = GetCookie('AccessToken') || GetCookie('InplayerToken');
  const configId = featureFlags?.jwplayer?.config_id;
  const clientId = featureFlags?.inplayer?.client_id;
  const clientSite = appConfig?.branding?.client_site;
  const footerLogoUrl = appConfig?.branding?.footer_logo_url;
  const appVersion = featureFlags?.platforms?.web?.latest_version;
  const supportEmail = featureFlags?.common?.app_data?.support_email;
  const supportEmailType = featureFlags?.common?.app_data?.support_email_type;

  const availableLanguages = featureFlags?.common.supported_languages;

  const termsOfUse = featureFlags?.common?.legal_docs.terms_of_use;
  const privacyPolicy = featureFlags?.common?.legal_docs?.privacy_policy;
  const aboutUs = featureFlags?.common?.legal_docs?.aboutUs;

  const landscapeThumbnail = appConfig?.branding?.video_horizontal_thumbnail;
  const portraitThumbnail = appConfig?.branding?.video_vertical_thumbnail;

  const domain = appConfig?.branding?.domain;
  const packageKey = isCleengSubscriptionEnabled
    ? config.integrations.cleeng?.useSandbox
      ? featureFlags?.subscription?.product_id_keys?.staging
      : featureFlags?.subscription?.product_id_keys?.production
    : config.integrations.jwp?.useSandbox
      ? featureFlags?.subscription?.product_id_keys?.staging
      : featureFlags?.subscription?.product_id_keys?.production;

  const mobileAppsLinks = appConfig?.footer?.mobile_apps_links;

  //api
  const customBaseApiUrl = featureFlags?.common?.custom_base_api_url;


  return {
    clientSite,
    supportEmail,
    supportEmailType,
    availableLanguages,
    termsOfUse,
    privacyPolicy,
    aboutUs,
    landscapeThumbnail,
    portraitThumbnail,
    configId,
    clientId,
    appVersion,
    isUser,
    domain,
    packageKey,
    mobileAppsLinks,
    footerLogoUrl,
    customBaseApiUrl
  };
};
